<app-mobile-page-shell [hideBottomNav]="mobileView !== 'tables'">

  <!-- ── OVERVIEW VIEW ─────────────────────────────────────────────── -->
  <ng-container *ngIf="mobileView === 'overview'">
    <!-- <app-mobile-metric-ribbon [metrics]="overviewMetrics"></app-mobile-metric-ribbon> -->

    <div class="m-dash-mobile-content">

      <!-- Inventory Value card -->
      <div class="m-dash-overview-card m-dash-overview-card--inventory mx-3 mt-3" *ngIf="dashboardSummary">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--inventory">
            <i class="bi bi-box-seam"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Inventory Value</h6>
            <small class="text-muted">Products &amp; raw material totals</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Raw Materials</span>
            <span class="m-dash-overview-value">{{ dashboardSummary.totalRawMaterialValue | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Products</span>
            <span class="m-dash-overview-value">{{ dashboardSummary.totalProductValue | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Overheads card -->
      <div class="m-dash-overview-card m-dash-overview-card--overheads mx-3 mt-3" *ngIf="dashboardSummary">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--overheads">
            <i class="bi bi-layers"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Overheads</h6>
            <small class="text-muted">Fixed &amp; variable cost totals</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Fixed Overheads</span>
            <span class="m-dash-overview-value">{{ dashboardSummary.totalFixedOverheads | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Variable Overheads</span>
            <span class="m-dash-overview-value">{{ dashboardSummary.totalVariableOverheads | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
        
          <div class="m-dash-overview-item m-dash-overview-item--total">
            <span class="m-dash-overview-label">Total Cost</span>
            <span class="m-dash-overview-value fw-bold">
              {{ (dashboardSummary.totalRawMaterialValue + dashboardSummary.totalProductValue + dashboardSummary.totalFixedOverheads + dashboardSummary.totalVariableOverheads) | currency:'ZAR':'symbol':'1.2-2' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Manufacturing Orders card -->
      <div class="m-dash-overview-card m-dash-overview-card--orders mx-3 mt-3 mb-3" *ngIf="dashboardSummary">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--orders">
            <i class="bi bi-gear-fill"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Manufacturing Orders</h6>
            <small class="text-muted">Production status overview</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Total Orders</span>
            <span class="m-dash-overview-value">{{ dashboardSummary.totalOrders }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Pending</span>
            <span class="m-dash-overview-value" [class.text-warning]="dashboardSummary.totalPendingOrders > 0">{{ dashboardSummary.totalPendingOrders }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">In Progress</span>
            <span class="m-dash-overview-value text-info">{{ dashboardSummary.totalInProgressOrders }}</span>
          </div>
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Completed Today</span>
            <span class="m-dash-overview-value text-success">{{ dashboardSummary.totalCompletedTodayOrders }}</span>
          </div>
        </div>
      </div>

    </div>
  </ng-container>

  <!-- ── TABLES VIEW ───────────────────────────────────────────────── -->
  <ng-container *ngIf="mobileView === 'tables'">
    <div class="m-dash-tab-ribbon">
      <app-mobile-metric-ribbon [metrics]="tabMetrics"></app-mobile-metric-ribbon>
    </div>

    <div class="m-dash-mobile-content">

      <!-- RAW MATERIALS TAB -->
      <div *ngIf="activeTab === 'raw'">
        <div class="m-section m-section--raw">
          <div class="m-section-header">
            <div class="m-section-icon"><i class="bi bi-box-seam"></i></div>
            <div class="m-section-header-text"><h6 class="m-section-title">Raw Materials</h6></div>
          </div>
          <div class="m-cfg-toolbar m-cfg-toolbar--inline">
            <div class="m-cfg-toolbar-row">
              <div class="m-cfg-search">
                <i class="bi bi-search"></i>
                <input type="text" [(ngModel)]="rawSearch" placeholder="Search materials…" />
                <button *ngIf="rawSearch" class="m-cfg-search-clear" (click)="rawSearch=''">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <button class="m-cfg-filter-toggle" [class.active]="rawFiltersOpen || selectedRawUOM"
                (click)="rawFiltersOpen = !rawFiltersOpen">
                <i class="bi bi-funnel"></i>
              </button>
            </div>
            <div class="m-cfg-filter-panel" *ngIf="rawFiltersOpen">
              <div class="m-cfg-select-row">
                <div class="m-cfg-select-group">
                  <label class="m-cfg-select-label">Unit of Measure</label>
                  <app-single-select-dropdown
                    [options]="rawUOMOptions"
                    [selectedValue]="selectedRawUOM"
                    placeholder="All Units"
                    (selectedValueChange)="selectedRawUOM = $event">
                  </app-single-select-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-cards-area">
          <div *ngIf="filteredRaw.length === 0" class="inv-empty-state">
            <i class="bi bi-box-seam fs-2 text-muted d-block mb-2"></i>
            <p class="text-muted">No raw materials match your filters.</p>
          </div>
          <app-mobile-data-card
            *ngFor="let item of filteredRawPaged; let i = index"
            [title]="item.materialName"
            [fields]="rawFields(item)"
            [primaryValue]="'R ' + (item.value | number:'1.2-2')"
            [badgeLabel]="'Raw Material'"
            [animationDelay]="i * 60">
          </app-mobile-data-card>
          <div *ngIf="filteredRawTotalPages > 1" class="inv-pagination">
            <button class="inv-page-btn" [disabled]="rawCurrentPage === 1" (click)="changeRawPage(rawCurrentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="inv-page-info">{{ rawCurrentPage }} / {{ filteredRawTotalPages }}</span>
            <button class="inv-page-btn" [disabled]="rawCurrentPage === filteredRawTotalPages" (click)="changeRawPage(rawCurrentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- PRODUCTS TAB -->
      <div *ngIf="activeTab === 'products'">
        <div class="m-section m-section--products">
          <div class="m-section-header">
            <div class="m-section-icon"><i class="bi bi-box"></i></div>
            <div class="m-section-header-text"><h6 class="m-section-title">Products</h6></div>
          </div>
          <div class="m-cfg-toolbar m-cfg-toolbar--inline">
            <div class="m-cfg-toolbar-row">
              <div class="m-cfg-search">
                <i class="bi bi-search"></i>
                <input type="text" [(ngModel)]="productsSearch" placeholder="Search products…" />
                <button *ngIf="productsSearch" class="m-cfg-search-clear" (click)="productsSearch=''">
                  <i class="bi bi-x"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-cards-area">
          <div *ngIf="filteredProducts.length === 0" class="inv-empty-state">
            <i class="bi bi-bag-check fs-2 text-muted d-block mb-2"></i>
            <p class="text-muted">No products match your search.</p>
          </div>
          <app-mobile-data-card
            *ngFor="let item of filteredProductsPaged; let i = index"
            [title]="item.productName"
            [fields]="productFields(item)"
            [primaryValue]="'R ' + (item.value | number:'1.2-2')"
            [badgeLabel]="'Product'"
            [animationDelay]="i * 60">
          </app-mobile-data-card>
          <div *ngIf="filteredProductsTotalPages > 1" class="inv-pagination">
            <button class="inv-page-btn" [disabled]="productsCurrentPage === 1" (click)="changeProductsPage(productsCurrentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="inv-page-info">{{ productsCurrentPage }} / {{ filteredProductsTotalPages }}</span>
            <button class="inv-page-btn" [disabled]="productsCurrentPage === filteredProductsTotalPages" (click)="changeProductsPage(productsCurrentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- FIXED OVERHEADS TAB -->
      <div *ngIf="activeTab === 'fixed'">
        <div class="m-section m-section--fixed-oh">
          <div class="m-section-header">
            <div class="m-section-icon"><i class="bi bi-layers"></i></div>
            <div class="m-section-header-text"><h6 class="m-section-title">Fixed Overheads</h6></div>
          </div>
          <div class="m-cfg-toolbar m-cfg-toolbar--inline">
            <div class="m-cfg-toolbar-row">
              <div class="m-cfg-search">
                <i class="bi bi-search"></i>
                <input type="text" [(ngModel)]="fixedSearch" placeholder="Search fixed costs…" />
                <button *ngIf="fixedSearch" class="m-cfg-search-clear" (click)="fixedSearch=''">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <button class="m-cfg-filter-toggle" [class.active]="fixedFiltersOpen || selectedFixedPeriod"
                (click)="fixedFiltersOpen = !fixedFiltersOpen">
                <i class="bi bi-funnel"></i>
              </button>
            </div>
            <div class="m-cfg-filter-panel" *ngIf="fixedFiltersOpen">
              <div class="m-cfg-select-row">
                <div class="m-cfg-select-group">
                  <label class="m-cfg-select-label">Payment Period</label>
                  <app-single-select-dropdown
                    [options]="fixedPeriodOptions"
                    [selectedValue]="selectedFixedPeriod"
                    placeholder="All Periods"
                    (selectedValueChange)="selectedFixedPeriod = $event">
                  </app-single-select-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-cards-area">
          <div *ngIf="filteredFixed.length === 0" class="inv-empty-state">
            <i class="bi bi-receipt fs-2 text-muted d-block mb-2"></i>
            <p class="text-muted">No fixed overheads match your filters.</p>
          </div>
          <app-mobile-data-card
            *ngFor="let item of filteredFixedPaged; let i = index"
            [title]="item.name"
            [fields]="fixedFields(item)"
            [primaryValue]="'R ' + (item.amount | number:'1.2-2')"
            [badgeLabel]="'Fixed'"
            [animationDelay]="i * 60">
          </app-mobile-data-card>
          <div *ngIf="filteredFixedTotalPages > 1" class="inv-pagination">
            <button class="inv-page-btn" [disabled]="fixedCurrentPage === 1" (click)="changeFixedPage(fixedCurrentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="inv-page-info">{{ fixedCurrentPage }} / {{ filteredFixedTotalPages }}</span>
            <button class="inv-page-btn" [disabled]="fixedCurrentPage === filteredFixedTotalPages" (click)="changeFixedPage(fixedCurrentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- VARIABLE OVERHEADS TAB -->
      <div *ngIf="activeTab === 'variable'">
        <div class="m-section m-section--variable-oh">
          <div class="m-section-header">
            <div class="m-section-icon"><i class="bi bi-graph-up"></i></div>
            <div class="m-section-header-text"><h6 class="m-section-title">Variable Overheads</h6></div>
          </div>
          <div class="m-cfg-toolbar m-cfg-toolbar--inline">
            <div class="m-cfg-toolbar-row">
              <div class="m-cfg-search">
                <i class="bi bi-search"></i>
                <input type="text" [(ngModel)]="variableSearch" placeholder="Search variable costs…" />
                <button *ngIf="variableSearch" class="m-cfg-search-clear" (click)="variableSearch=''">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <button class="m-cfg-filter-toggle" [class.active]="variableFiltersOpen || selectedVariableUOM"
                (click)="variableFiltersOpen = !variableFiltersOpen">
                <i class="bi bi-funnel"></i>
              </button>
            </div>
            <div class="m-cfg-filter-panel" *ngIf="variableFiltersOpen">
              <div class="m-cfg-select-row">
                <div class="m-cfg-select-group">
                  <label class="m-cfg-select-label">Unit of Measure</label>
                  <app-single-select-dropdown
                    [options]="variableUOMOptions"
                    [selectedValue]="selectedVariableUOM"
                    placeholder="All Units"
                    (selectedValueChange)="selectedVariableUOM = $event">
                  </app-single-select-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-cards-area">
          <div *ngIf="filteredVariable.length === 0" class="inv-empty-state">
            <i class="bi bi-graph-up fs-2 text-muted d-block mb-2"></i>
            <p class="text-muted">No variable overheads match your filters.</p>
          </div>
          <app-mobile-data-card
            *ngFor="let item of filteredVariablePaged; let i = index"
            [title]="item.name"
            [fields]="variableFields(item)"
            [primaryValue]="'R ' + (item.totalCost | number:'1.2-2')"
            [badgeLabel]="'Variable'"
            [animationDelay]="i * 60">
          </app-mobile-data-card>
          <div *ngIf="filteredVariableTotalPages > 1" class="inv-pagination">
            <button class="inv-page-btn" [disabled]="variableCurrentPage === 1" (click)="changeVariablePage(variableCurrentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="inv-page-info">{{ variableCurrentPage }} / {{ filteredVariableTotalPages }}</span>
            <button class="inv-page-btn" [disabled]="variableCurrentPage === filteredVariableTotalPages" (click)="changeVariablePage(variableCurrentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>


    </div>

    <!-- Total row lives outside the scroll container so it stays pinned -->
    <!-- <div class="m-dash-total-row m-dash-total-row--anchored">
      <span class="m-dash-total-label">Total</span>
      <span class="m-dash-total-value">
        {{ (activeTab === 'raw' ? rawTotal :
            activeTab === 'products' ? productsTotal :
            activeTab === 'fixed' ? fixedTotal :
            variableTotal) | currency:'ZAR':'symbol':'1.2-2' }}
      </span>
    </div> -->
  </ng-container>

  <!-- ── CHARTS VIEW ───────────────────────────────────────────────── -->
  <ng-container *ngIf="mobileView === 'charts'">
    <div class="m-dash-mobile-content inv-mobile-charts">

      <div class="m-section m-section--alloc">
        <div class="m-section-header">
          <div class="m-section-icon"><i class="bi bi-pie-chart-fill"></i></div>
          <div class="m-section-header-text">
            <h6 class="m-section-title">Cost Allocation</h6>
          </div>
        </div>
        <div class="inv-bar-chart-wrap" [style.height]="costAllocChartHeight">
          <canvas *ngIf="costAllocationData"
            baseChart
            [data]="costAllocationData"
            [options]="costAllocationOptions"
            type="bar">
          </canvas>
          <div *ngIf="!costAllocationData" class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center p-4">
              <i class="bi bi-bar-chart fs-1 text-muted mb-2"></i>
              <p class="mb-0 text-muted small">No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div class="m-section m-section--trend">
        <div class="m-section-header">
          <div class="m-section-icon"><i class="bi bi-graph-up-arrow"></i></div>
          <div class="m-section-header-text">
            <h6 class="m-section-title">Cost Trend</h6>
            <span class="m-section-subtitle">Last 6 months</span>
          </div>
        </div>
        <div class="m-dash-trend-wrap">
          <canvas *ngIf="profitTrendData && profitTrendData.labels"
            baseChart
            [data]="profitTrendData"
            [options]="profitTrendOptions"
            type="bar">
          </canvas>
          <div *ngIf="!profitTrendData || !profitTrendData.labels" class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center p-4">
              <i class="bi bi-graph-up fs-1 text-muted mb-2"></i>
              <p class="mb-0 text-muted small">No data available</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </ng-container>

</app-mobile-page-shell>
